import React, { useEffect, useRef, useState } from "react";
import { darkTheme } from "@yleisradio/yds-core";
import styled from "styled-components";

import { newId } from "../../helpers/uid";
import i18n from "../../service/i18n";
import { focusColor } from "../../styles/variables";

const ShareFromLabel = styled.label`
  color: ${darkTheme.TEXT_DEFAULT};
  display: block;
  font-size: 16px;
  line-height: 16px;
  margin-right: 3px;
  user-select: none;

  &:before {
    border: 1px solid ${darkTheme.BORDER};
    content: "";
    cursor: pointer;
    height: 16px;
    left: 0;
    position: absolute;
    transition: transform 0.28s ease;
    width: 16px;
  }

  &:after {
    border-bottom: 2px solid ${darkTheme.BORDER};
    border-left: 2px solid ${darkTheme.BORDER};
    content: "";
    display: block;
    height: 5px;
    left: 3px;
    position: absolute;
    top: 8px;
    transform: rotate(-45deg) scale(0);
    width: 10px;
  }

  input[type="checkbox"]:checked ~ &:after {
    transform: rotate(-45deg) scale(1);
  }

  input[type="checkbox"]:focus ~ &:before {
    border: 1px solid ${focusColor};
  }
`;

const ShareFromWrapper = styled.div`
  display: flex;
  margin-top: 16px;
`;

const ShareFromCheckWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

const ShareFromCheckbox = styled.input`
  cursor: pointer;
  height: 18px;
  margin-right: 3px;
  opacity: 0;
  width: 18px;
`;

const ShareFromInput = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid ${darkTheme.BORDER};
  color: ${darkTheme.TEXT_DEFAULT};
  font-size: 16px;
  padding-bottom: 3px;
  padding-top: 5px;
  text-align: center;

  &:focus {
    outline: 1px solid ${focusColor};
  }
`;

const ShareFrom = ({
  checkboxToggle,
  language,
  shareFromChanged,
  shareFromInput
}: {
  language: string;
  shareFromInput: string;
  checkboxToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
  shareFromChanged: (event: React.FocusEvent<HTMLInputElement>) => void;
}) => {
  const [input, setInput] = useState(shareFromInput);
  const id = useRef(newId("cb"));

  useEffect(() => {
    setInput(shareFromInput);
  }, [shareFromInput]);

  return (
    <ShareFromWrapper>
      <ShareFromCheckWrapper>
        <ShareFromCheckbox
          id={id.current}
          onChange={checkboxToggle}
          type="checkbox"
        />
        <ShareFromLabel htmlFor={id.current}>
          {i18n("jaa_kohdasta", { language })}
        </ShareFromLabel>
      </ShareFromCheckWrapper>
      <ShareFromInput
        type="text"
        size={7}
        value={input}
        onBlur={shareFromChanged}
        onChange={e => setInput(e.target.value)}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.key === "Enter") {
            event.currentTarget.blur();
          }
        }}
      />
    </ShareFromWrapper>
  );
};

export default ShareFrom;
